export default "__VITE_ASSET__BHAygEg3__"